import * as EmailValidator from 'email-validator'
import { DateTime } from 'luxon'
import { isValidPhoneNumber } from 'react-phone-number-input'

import i18n from '../i18n'

export const hasErrors = errors => {
  return Object.keys(errors).length > 0
}

export const requiredValidation = () => {
  return 'Campo obrigatório'
}

export const requiredAllowZeroValidation = value => {
  return (value !== undefined && value !== null) || 'Campo obrigatório'
}

export const emailValidation = email => {
  if (!email) return true
  return EmailValidator.validate(email) || i18n.t('errors:invalid_email')
}

export const ageGroupValidation = (birthdate, profile) => {
  if (!birthdate || !profile) return true

  if (!profile?.ageGroup) return true

  const birthdateObj = DateTime.fromISO(birthdate)
  const age = Math.floor(DateTime.now().diff(birthdateObj, 'years').years)

  const { minAge, maxAge, minInclusive, maxInclusive } = profile.ageGroup

  if (minAge) {
    const isUnderMinAge = minInclusive ? age < minAge : age <= minAge
    if (isUnderMinAge) {
      return i18n.t('errors:date_incompatible_error')
    }
  }

  if (maxAge) {
    const isOverMaxAge = maxInclusive ? age > maxAge : age >= maxAge
    if (isOverMaxAge) {
      return i18n.t('errors:date_incompatible_error')
    }
  }

  return true
}

export const nifValidation = nif => {
  if (!nif) return true
  if (
    !['1', '2', '3', '5', '6', '8'].includes(nif.substr(0, 1)) &&
    !['45', '70', '71', '72', '77', '79', '90', '91', '98', '99'].includes(nif.substr(0, 2))
  )
    return false

  let total = nif[0] * 9 + nif[1] * 8 + nif[2] * 7 + nif[3] * 6 + nif[4] * 5 + nif[5] * 4 + nif[6] * 3 + nif[7] * 2

  let modulo11 = total - parseInt(total / 11) * 11
  let comparador = modulo11 == 1 || modulo11 == 0 ? 0 : 11 - modulo11

  return nif[8] == comparador || i18n.t('errors:tax_id_error')
}

export const postalCodeValidation = postalCode => {
  const pattern = /^\d{4}-\d{3}$/
  return postalCode == null || pattern.test(postalCode) || i18n.t('errors:postal_code_error')
}

export const phoneNumberValidation = (phone, required) => {
  let number = phone?.number ?? phone ?? ''

  if (!required && !number) return true
  return isValidPhoneNumber(number) || i18n.t('errors:invalid_phone_number')
}

export const passwordMatchValidation = (value, matchingValue) => {
  return value === matchingValue || i18n.t('errors:passwords_dont_match')
}

export const minLengthValidation = (value, length, field) => {
  return value.length >= length || i18n.t('errors:minLength', { field, length })
}

export const maxLengthValidation = (value, length, field) => {
  return value.length <= length || i18n.t('errors:maxLength', { field, length })
}

export const requiredArrayValidation = affected => {
  return affected.length > 0 || i18n.t('common:required_field')
}

export const arrivalDepartureTimeValidation = (startTime, endTime) => {
  if (startTime >= endTime) {
    return i18n.t('errors:incorrect_arrival_departure_time')
  }

  return true
}
